import { Card, Typography } from "@mui/material";
import { useDropzone } from "react-dropzone";
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";

export const ImageField = ({ fieldName, currentImage }) => {
  const { setFieldValue } = useFormikContext();
  const [preview, setPreview] = useState();
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: ["image/png", "image/jpeg", "image/gif"],
    maxFiles: 1,
    onDrop: ([file]) => {
      setFieldValue(fieldName, file);
      //todo: should we remove the current preview?
      setPreview(URL.createObjectURL(file));
    },
  });
  useEffect(() => {
    // Revoke the data uri to avoid memory leaks
    return () => {
      if (preview) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);
  return (
    <Card
      sx={{
        border: "1px solid #eee",
        borderRadius: 1,
        minHeight: 40,
        textAlign: "center",
        py: 2,
        my: 2,
      }}
      elevation={7}
      {...getRootProps({ className: "dropzone" })}
    >
      {(preview || currentImage) && (
        <img
          alt="Dealer Logo"
          style={{ maxWidth: 200, maxHeight: 200 }}
          src={preview || currentImage}
          // Revoke data uri after image is loaded
          onLoad={() => {
            URL.revokeObjectURL(preview);
          }}
        />
      )}
      <input {...getInputProps()} />
      {isDragActive ? (
        <Typography>Drop the file here...</Typography>
      ) : (
        <Typography>Drag an image here, or click to select</Typography>
      )}
    </Card>
  );
};
